import React from 'react'
import PropTypes from 'prop-types'
import { TextBlock as HorizonTextBlock } from 'ascential-horizon'

const EmbedIframe = ({ html }) => <HorizonTextBlock html={html} />

EmbedIframe.propTypes = {
  html: PropTypes.string.isRequired,
}

export default EmbedIframe
